import { render, staticRenderFns } from "./SBVerify.vue?vue&type=template&id=0ce58ac0"
import script from "./SBVerify.vue?vue&type=script&lang=js"
export * from "./SBVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports